var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVerEventoBlanco(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 91.669,
    height: 91.669,
    viewBox: "0 0 91.669 91.669",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_95",
    "data-name": "Grupo 95",
    transform: "translate(-4980.92 -868.331)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rect\\xE1ngulo_62",
    "data-name": "Rect\\xE1ngulo 62",
    transform: "translate(5072.589 960) rotate(180)",
    fill: "#fff",
    stroke: "#b0b0b0",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }, /*#__PURE__*/React.createElement("rect", {
    width: 91.669,
    height: 91.669,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.125,
    y: 0.125,
    width: 91.419,
    height: 91.419,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "ver_evento",
    "data-name": "ver evento",
    transform: "translate(4990.332 938.401)",
    fill: "#1a1a1a",
    fontSize: 20.107,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "ver"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 13.955
  }, "evento")), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_61",
    "data-name": "Grupo 61"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_85",
    "data-name": "Trazado 85",
    d: "M5002.663,878.007v11.166H4991.5",
    fill: "none",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_15",
    "data-name": "L\\xEDnea 15",
    x2: 11.056,
    y2: 11.056,
    transform: "translate(4991.607 878.118)",
    fill: "none",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerEventoBlanco);
export default __webpack_public_path__ + "static/media/verEventoBlanco.03520d1cc33a2898d7d2b3c07a49bc0d.svg";
export { ForwardRef as ReactComponent };